export default {
    title: 'Language settings',
    locales: {
        de: 'german',
        en: 'englisch'
    },
    success: 'Your language settings are successfully submitted',
    action: 'Submit',
    field: 'Default language'
}
